module.exports = __webpack_public_path__ + "img/product_dietz_meco.5c4633ab.jpg";